import classnames from 'classnames';
import { Badge } from 'reactstrap';
import { NormalButton } from '@/shared/ui';
import { defaultControlModalValue } from '@/entities/report';
import useButtonAddNewEvent from './useButtonAddNewEvent';

/**
 * Renders the draft-events panel with its pending count and an Add New Event action. Clicking the panel opens the new-events modal by resetting the control-modal flags with isShowNewEvents set, the inner button calls onClickAddNewEvent, and the badge turns red once eventLength rises above zero.
 *
 * @returns The rendered draft panel with its count badge and add-event button.
 */
const ButtonAddNewEvent = () => {
  const { eventLength, onClickAddNewEvent, setControlModal } = useButtonAddNewEvent();

  return (
    <button
      id="draft-btn"
      className="draft-btn"
      onClick={() => {
        setControlModal({
          ...defaultControlModalValue,
          isShowNewEvents: true,
        });
      }}
    >
      <Badge className={classnames(eventLength > 0 ? 'custom-badge-red' : 'custom-badge-gray')}>
        {eventLength}
      </Badge>
      <div className="draft-title">Draft</div>
      <div className="draft-description">Click to view all.</div>
      <NormalButton
        id="beats-add-new-event-btn"
        className="add-new-event-btn"
        buttonName="Add New Event"
        onClick={onClickAddNewEvent}
      />
    </button>
  );
};

export default ButtonAddNewEvent;
